/* Filtro por acabado en el catálogo (plan/30 §5.2; plan/31 A4; arreglo del 15-oct-2026, general 14-oct).
   La banda de acabados lleva a /collections/catalogo?filter.v.option.color=<acabado> o, en los colores con
   colección propia (Eclipse, Urban Grey…), a esa colección, que lista todo el catálogo: en ese caso
   `tt-acabados` deja el valor en `.tt-acabados__activo[data-acabado-activo]`.
   Cuando el filtro por opción Color esté activo en Search & Discovery, Shopify filtra en servidor y las
   tarjetas ya salen en ese color; este script no hace nada. Hasta entonces:
   1. oculta las tarjetas cuyo selector de muestras no tiene ese acabado (los bancos y el 8 puertas no
      tienen madera; el 8 puertas tampoco Eclipse) y corrige el recuento «N artículos»;
   2. marca en cada tarjeta que queda la muestra de ese acabado (la que cambia la imagen al pulsarla);
   3. marca la pastilla activa de la banda.
   Una tarjeta sin selector de muestras no se puede juzgar y se queda. El orden «Próximamente al final» no
   es de aquí: lo hace `main-collection.liquid` en servidor.
   ponytail: se retira el día que el filtro nativo esté activo. */
(() => {
  const activo = document.querySelector('.tt-acabados__activo');
  const acabado = (activo && activo.dataset.acabadoActivo) || new URLSearchParams(location.search).get('filter.v.option.color');
  if (!acabado) return;
  if (!activo && document.querySelector('input[name="filter.v.option.color"]')) return;

  const ocultar = () => {
    const tarjetas = [...document.querySelectorAll('.product-grid__item')];
    let visibles = 0;
    tarjetas.forEach((li) => {
      const radios = [...li.querySelectorAll('swatches-variant-picker-component input[type="radio"]')];
      const sobra = radios.length > 0 && !radios.some((r) => r.value === acabado);
      li.style.display = sobra ? 'none' : '';
      if (!sobra) visibles += 1;
    });
    // Estado vacío: si ningún acabado coincide, no se oculta nada (mejor la lista entera que una página en blanco).
    if (visibles === 0) {
      tarjetas.forEach((li) => { li.style.display = ''; });
      return;
    }
    // El texto trae el número en cualquier idioma («6 artículos», «6 Artikel»): se cambia solo el número.
    document.querySelectorAll('.products-count-wrapper span').forEach((s) => {
      if (/\d+/.test(s.textContent)) s.textContent = s.textContent.replace(/\d+/, visibles);
    });
  };

  const marcar = () => {
    document.querySelectorAll('product-card swatches-variant-picker-component input[type="radio"]').forEach((input) => {
      if (input.value !== acabado) return;
      // Si el servidor ya la dejó marcada (única variante comprable) la imagen sigue siendo la del primer
      // color: se desmarca para que el clic dispare el cambio de imagen (la pequeña de 4 puertas, 15-oct).
      input.checked = false;
      input.click();
    });
    document.querySelectorAll('.tt-acabados__enlace[data-acabado]').forEach((a) => {
      const esActivo = a.dataset.acabado === acabado;
      a.classList.toggle('is-active', esActivo);
      if (esActivo) a.setAttribute('aria-current', 'true');
    });
  };

  const arrancar = () => {
    ocultar();
    // Si otro filtro (puertas, precio) vuelve a pintar la rejilla, se aplica de nuevo.
    const lista = document.querySelector('results-list');
    if (lista) {
      new MutationObserver((cambios) => {
        const nuevas = cambios.some((c) => [...c.addedNodes].some((n) => n.nodeType === 1 && (n.matches('.product-grid__item') || n.querySelector('.product-grid__item'))));
        if (nuevas) { ocultar(); marcar(); }
      }).observe(lista, { childList: true, subtree: true });
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();

  // El clic tiene que llegar cuando el selector de muestras y la tarjeta ya son componentes: antes,
  // el radio se marca pero nadie escucha el `change` y la imagen no cambia (medido el 22-sep).
  const listos = ['product-card', 'swatches-variant-picker-component'].map((n) => customElements.whenDefined(n));
  Promise.all(listos).then(() => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', marcar);
    else marcar();
  });
})();
